import type { ReactNode } from 'react';

export const symbol_game_stick_r3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-786 380-919h200L480-786Zm241 429q99-52 99-125.92t-99-126Q622-661 480-661t-241 52.08q-99 52.08-99 126T239-357q99 52 241 52t241-52Zm-47 81v136q0 24.75-17.62 42.37Q638.75-80 614-80H345q-24.75 0-42.37-17.63Q285-115.25 285-140v-136q-92-31-148.5-85.51Q80-416.02 80-482.8 80-582 196.5-651 313-720 480-720t283.5 69.25Q880-581.51 880-483q0 67.24-56.5 122.12Q767-306 674-276ZM480-483Zm-38.5 101.5Q446-386 446-392v-67h37l44 75q2 3 5.38 5 3.39 2 7.62 2 8.87 0 12.93-7.5Q557-392 552-400l-42-68q20-8 30-21.36 10-13.37 10-33.64 0-30-19-45t-56-15h-43.87q-6.05 0-10.59 4.5T416-568v176q0 6 4.5 10.5T431-377q6 0 10.5-4.5ZM446-487v-67h27q23 0 34.5 8t11.5 24.94Q519-503 508-495t-35 8h-27Z"
		/>
	</svg>
);
